import { ReactNode, useEffect } from 'react';
import { useI18n } from '~/i18n/i18n';

interface RTLWrapperProps {
  children: ReactNode;
}

export default function RTLWrapper({ children }: RTLWrapperProps) {
  const { locale } = useI18n();
  const isRTL = locale === 'he';


  // Keep document direction/language in sync when the locale changes at runtime
  // (the initial values are already set correctly by SSR on the <html> tag, so
  // there's no flash on first paint and no need to force a reflow).
  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.body.dir = isRTL ? 'rtl' : 'ltr';
  }, [locale, isRTL]);

  return <>{children}</>;
}
